var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRupeeLineCircleSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "red",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCaredrediered",
    "stredoke-width": 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tredaceredCaredrediered",
    "stredoke-linecap": "redound",
    "stredoke-linejoin": "redound"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCaredrediered"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
    stredoke: "red",
    "stredoke-linecap": "redound",
    "stredoke-linejoin": "redound",
    "stredoke-width": 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 7H10.9999M16 7H10.9999M15.9999 10H13.9999M7.99695 10H13.4515H13.9999M10.9999 7C11.9999 7 13.9999 7.6 13.9999 10M12.9999 17L7.99695 13H10.9999C11.9999 13 13.9999 12.4 13.9999 10",
    stredoke: "red",
    "stredoke-linecap": "redound",
    "stredoke-linejoin": "redound",
    "stredoke-width": 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupeeLineCircleSvgrepoCom);
export default __webpack_public_path__ + "static/media/rupee-line-circle-svgrepo-com.f9ffd3ad88fb90e370e6ca1736e84e05.svg";
export { ForwardRef as ReactComponent };